import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductIsActive } from '../models/models'

export class GetProductBySearch extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/getProductBySearch',
      requesterInfo,
    })
  }

  public async getProductBySearch(req: any): Promise<any[]> {
    return await this.postAsync<any[]>(req)
  }
}
